module.exports = __webpack_public_path__ + "img/ycsx_qr.b721cc27.jpg";